module.exports = __webpack_public_path__ + "img/changjing4.9e08fd1e.png";